import { createContext } from 'react';

// ----------------------------------------------------------------------

export const AuthContext = createContext(undefined);


// import { createContext, useContext, useState } from 'react';
// import {login as signInOTPRequest} from "src/services/client.js";
// // ----------------------------------------------------------------------


// const AuthContext = createContext({});

// const AuthProvider = ({ children }) => {
//     const [user, setUser] = useState(null)

//     const login = async (phoneNumber) => {
//         return new Promise((resolve, reject) => {
//             signInOTPRequest(phoneNumber).then(res => {
//                 const jwtToken = res.headers-"authorization";
//                 //save token
//             })
//         })
//     }
// }

// export const AuthContext = () => useContext(AuthContext);
